module.exports = __webpack_public_path__ + "img/empty_cart.b7346bc3.svg";